import axios from './axiosInstance'

const setDefaults = () => {
  axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencode'
  axios.defaults.headers.common.Accept          = 'application/json'
}

const Login = (data) => {
  const { token } = data
  setDefaults()
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios.post('/auth/login/', data)
      .then(response => resolve(response.data))
      .catch((error) => { reject(error.response) })
  })
}

const Register = (data) => {
  setDefaults()
  return new Promise((resolve, reject) => {
    axios.post('/auth/register', data)
      .then(response => resolve(response.data))
      .catch((error) => { reject(error.response) })
  })
}

const RegisterGoogle = (data) => {
  setDefaults()
  return new Promise((resolve, reject) => {
    axios.post('/auth/registerGoogle', data)
      .then(response => resolve(response.data))
      .catch((error) => { reject(error.response) })
  })
}

const RegisterFacebook = (data) => {
  setDefaults()
  return new Promise((resolve, reject) => {
    axios.post('/auth/registerFacebook', data)
      .then(response => resolve(response.data))
      .catch((error) => { reject(error.response) })
  })
}

const RegisterApple = (data) => {
  setDefaults()
  return new Promise((resolve, reject) => {
    axios.post('/auth/registerApple', data)
      .then(response => resolve(response.data))
      .catch((error) => { reject(error.response) })
  })
}

const CreateVenueLoginLink = ({ token, email, alias }) => {
  setDefaults()
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios.post('/auth/createVenueLoginLink', { alias, email })
      .then(response => resolve(response.data))
      .catch((error) => { reject(error.response) })
  })
}

export {
  Login,
  Register,
  RegisterGoogle,
  RegisterFacebook,
  RegisterApple,
  CreateVenueLoginLink
}
